module.exports = __webpack_public_path__ + "static/media/addQuestion.1bc72758.png";